<template>
<div class="chapter">
<div class="inner_page">
<div class="ch-box">
<h2 class="ch-title">Acknowledgments</h2>
</div>
<p class="noindent">I am blessed to have so many people and experiences in my life to be grateful for. Thank you to my family and friends for your support, encouragement, inspiration, and wisdom.</p>
<p class="indent">Love and honor to my beautiful wife, Sarah, for your unlimited devotion through the happiest and toughest times of my life. Thank you for all that you are and for all of your ‘behind the scenes’ acts that support the foundation of You Evolving Now, LLC. To my children: Xiomara, André, Mason, and Sky. I love you! I am complete with you all in my life.</p>
<p class="indent">To my father, Robert, thank you for being my calming rock. Your words, sincerity, and patience continue to leave me in awe. To my mother, Sherri, “I love you” seems too simple a thing to say. Your truth has never failed me; even back when Randy and I use to barge into the bathroom just to speak to you! To my brother, Randy, I love you til the end. Many many thanks to my other family members and friends!</p>
<p class="indent">Lastly, a special thanks to my friend Ed Burns. Thank you for supporting my vision; recommending and motivating me to start writing 3 blogs per week so many years ago; creating an unstoppable passion and ability I didn’t know I possessed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?17cd7160